import { create } from 'zustand'

import { PendingUserMessage } from 'types/PendingUserMessage'

type setPendingUserMessageParams = {
  pendingUserMessage: PendingUserMessage
  replacingMessageId?: string
}

type PendingUserMessageState = {
  clearPendingUserMessage: VoidFunction
  isPendingUserMessageError?: boolean
  pendingUserMessage?: PendingUserMessage
  replacingMessageId?: string
  setIsPendingUserMessageError: (isError: boolean) => void
  setPendingUserMessage: ({
    pendingUserMessage,
    replacingMessageId,
  }: setPendingUserMessageParams) => void
}

type InitialState = Pick<
  PendingUserMessageState,
  'isPendingUserMessageError' | 'pendingUserMessage' | 'replacingMessageId'
>

const initialState: InitialState = {
  isPendingUserMessageError: false,
  pendingUserMessage: undefined,
  replacingMessageId: undefined,
}

export const usePendingUserMessageState = create<PendingUserMessageState>(
  set => ({
    ...initialState,
    clearPendingUserMessage: () => set(initialState),
    setIsPendingUserMessageError: (isError: boolean) =>
      set({ isPendingUserMessageError: isError }),
    setPendingUserMessage: ({ pendingUserMessage, replacingMessageId }) =>
      set({
        ...initialState,
        pendingUserMessage,
        replacingMessageId,
      }),
  }),
)

export const usePendingUserMessage = () =>
  usePendingUserMessageState(state => state.pendingUserMessage)

export const useClearPendingUserMessage = () =>
  usePendingUserMessageState(state => state.clearPendingUserMessage)

export const useIsPendingUserMessageError = () =>
  usePendingUserMessageState(state => state.isPendingUserMessageError)

export const useSetIsPendingUserMessageError = () =>
  usePendingUserMessageState(state => state.setIsPendingUserMessageError)

export const useSetPendingUserMessage = () =>
  usePendingUserMessageState(state => state.setPendingUserMessage)
